import React, {Fragment} from 'react';
import {Box, Skeleton} from '@mui/material';
import styles from './card-heading.module.scss';

interface CardHeadingProps {
  subtitle?: string;
  title: string;
  tooltip?: React.ReactNode;
  loading?: boolean;
}

export function CardHeading(props: CardHeadingProps): React.ReactElement {
  const TextWrapper = props.loading ? Skeleton : Fragment;
  return (
    <>
      <TextWrapper>
        <div className={styles.title}>
          {props.title}
          {props.tooltip}
        </div>
      </TextWrapper>
      {props.subtitle && (
        <Box mt="2px">
          <TextWrapper>
            <div className={styles.subtitle}>{props.subtitle}</div>
          </TextWrapper>
        </Box>
      )}
    </>
  );
}
